const tabTitles = document.querySelectorAll('.pdp-faq-tab-headings .pdp-faq-tab-head')
const tabs = document.querySelectorAll('.pdp-faq-tabs--wrapper .pdp-faq-tab')


function handleTabs() {
  //Switching tab titles
  tabTitles.forEach((tabTitle) => {
    tabTitle.classList.remove('active')
  })
  if(!this.classList.contains('active')){
    this.classList.add('active')
  }

  //Switching tabs
  tabs.forEach((tab) => {
    const activeTab = document.querySelector('.pdp-faq-tab-headings .pdp-faq-tab-head.active')
    if (tab.dataset.tabName === activeTab.dataset.tabName) {
      tab.classList.remove('hidden')
    }
    else {
      if(!tab.classList.contains('hidden')){
        tab.classList.add('hidden')
      }
    }
  })
}

tabTitles.forEach((tabTitle) => {
  tabTitle.addEventListener('click', handleTabs)
})


// for progress scroll bar

const scrollContainer = document.querySelector('.pdp-faq-tab-headings--wrapper');
const scrollProgress = document.querySelector('.scrollProgress');

scrollContainer.addEventListener('scroll', function() {
    const maxScroll = scrollContainer.scrollWidth - scrollContainer.clientWidth;
    let scrollPercentage = (scrollContainer.scrollLeft / maxScroll) * 100;
    scrollPercentage = Math.min(100 , scrollPercentage + 7)
    scrollProgress.style.width = scrollPercentage + '%';
});